export default {
    computed: {
        resourceName() {
            return this.$options.name.toLowerCase();
        },
    },
    created() {
        this.initCrudListeners()
    },

    beforeDestroy() {
        this.destroyCrudListeners()
    },

    methods: {
        initCrudListeners() {
            this.$root.$on(`created::${this.resourceName}`, this.handleCreated);
            this.$root.$on(`updated::${this.resourceName}`, this.handleUpdates);
            this.$root.$on(`deleted::${this.resourceName}`, this.handleDeleted);
        },

        destroyCrudListeners() {
            this.$root.$off(`created::${this.resourceName}`, this.handleCreated);
            this.$root.$off(`updated::${this.resourceName}`, this.handleUpdates);
            this.$root.$off(`deleted::${this.resourceName}`, this.handleDeleted);
        },

        handleCreated(data) {
            this.items.unshift(data);
            this.totalRows += 1;
            if (this.items.length > this.perPage) {
                this.items.pop();
            }
        },

        handleDeleted(id) {
            console.log(id)
            let index = this.items.findIndex(item => item.id === id);
            this.items.splice(index, 1);
        },

        handleUpdates(data) {
            let index = this.items.findIndex(item => item.id === data.id);
            this.items.splice(index, 1, data);
        }
    }
};
